import { schedulePriceQuoteV0 } from "../../../api/v0/book/book-flow/schedulePriceQuote";
import { pollPriceQuoteV0 } from "../../../api/v0/book/book-flow/pollPriceQuote";
import { schedulePaymentV0 } from "../../../api/v0/book/book-flow/schedulePayment";
import { pollFinalizedV0 } from "../../../api/v0/book/book-flow/pollFinalized";
import { closeSessionV0 } from "../../../api/v0/book/session/closeSession";

type Version = "v0";

export const getPurchaseRequestMetaProps = (): {
  version: Version;
} => {
  return {
    version: "v0",
  };
};

export const getPurchaseApis = () => {
  return {
    closeSession: closeSessionV0,
    schedulePriceQuote: schedulePriceQuoteV0,
    pollPriceQuote: pollPriceQuoteV0,
    schedulePayment: schedulePaymentV0,
    pollFinalized: pollFinalizedV0,
  };
};
